/* KL Member Pricing Value Prop — nav build K. Starts the sequence (or the still frame when motion is off)
   and scales the fixed 1160/390 drawing to the width it actually has, so the arrows stay on their prices. */
(function () {
  function fit(wrap) {
    var stage = wrap.querySelector('.kl-mvp__stage--wide');
    var narrow = wrap.querySelector('.kl-mvp__stage--narrow');
    var active = getComputedStyle(narrow).display !== 'none' ? narrow : stage;
    var natural = active === narrow ? 390 : 1160;
    var s = Math.min(active === narrow ? 1.5 : 1, wrap.clientWidth / natural); /* the phone drawing may grow to 1.5x on tablets */
    active.style.transform = 'scale(' + s + ')';
    /* the stage scales from its top-left corner, so centre it by its SCALED width (a centred box scaled from
       the left ran off the right edge — HOD K R2-1) */
    active.style.marginLeft = Math.max(0, (wrap.clientWidth - natural * s) / 2) + 'px';
    active.style.marginRight = '0';
    wrap.style.height = (active.offsetHeight * s) + 'px';
  }
  function init() {
    document.querySelectorAll('.kl-mvp').forEach(function (sec) {
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!still) sec.classList.add('is-playing'); /* no class = the still frame (CSS default) */
      var wrap = sec.querySelector('[data-kl-mvp-stage]');
      if (wrap) { fit(wrap); window.addEventListener('resize', function () { fit(wrap); }); setTimeout(function () { fit(wrap); }, 400); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
